import _ImageKeys from '../../figma/images.json'

export const ImageKeys = _ImageKeys
